import useSorting from "../useSorting";
import React from "react";

const useSortingTable = ({ columns, sortingKeys, sortingDefaults }) => {
	const { sortingState, currentSorting, toggleSorting } = useSorting(
		sortingKeys,
		sortingDefaults
	);

	const columnsWithSorting = React.useMemo(() => {
		return columns.map(column => {
			return {
				...column,
				sortable: !!sortingState[column.key],
				sortingDirection: sortingState[column.key]
			};
		});
	}, [columns, sortingState]);

	const sorting = React.useMemo(() => {
		if (!currentSorting) {
			return null;
		}

		return {
			column: currentSorting,
			direction: sortingState[currentSorting]
		};
	}, [currentSorting, sortingState]);

	return {
		columns: columnsWithSorting,
		toggleSorting,
		sorting
	};
};

export default useSortingTable;
